import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { fetchCampaignsHub } from "../../../services/automapBuyerLaunchApi";
import { LAUNCH_STATUS_LABELS, READINESS_STATUS_LABELS } from "../../../constants/automapBuyerLaunchConstants";
import { LaunchShell } from "./AdminLaunchShared";

export default function AdminCampaignsHubPage() {
  const [payload, setPayload] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    fetchCampaignsHub().then(setPayload).finally(() => setLoading(false));
  }, []);

  return (
    <LaunchShell active="hub" title="Campañas" description="Buyer launch Medellín/Antioquia.">
      {loading ? <p className="dealer-state-box">Cargando…</p> : null}
      {!loading && payload ? (
        <>
          <div className="dashboard-summary-grid">
            <div className="dashboard-summary-card">
              <span className="dashboard-summary-label">Estado launch</span>
              <strong>{LAUNCH_STATUS_LABELS[payload.config?.status] || payload.config?.status}</strong>
            </div>
            <div className="dashboard-summary-card">
              <span className="dashboard-summary-label">Readiness</span>
              <strong>{READINESS_STATUS_LABELS[payload.readinessStatus] || payload.readinessStatus}</strong>
            </div>
            <div className="dashboard-summary-card">
              <span className="dashboard-summary-label">Score</span>
              <strong>{payload.readinessScore ?? "—"}</strong>
            </div>
            <div className="dashboard-summary-card">
              <span className="dashboard-summary-label">Campañas</span>
              <strong>{payload.campaigns?.length ?? 0}</strong>
            </div>
          </div>
          <div style={{ display: "flex", gap: "0.5rem", flexWrap: "wrap" }}>
            <Link className="dealer-portal-btn" to="/admin/campaigns/launch">Dashboard launch</Link>
            <Link className="dealer-portal-btn" to="/admin/campaigns/launch/readiness">Readiness</Link>
            <Link className="dealer-portal-btn" to="/admin/campaigns/launch/daily-monitor">Daily monitor</Link>
            <Link className="dealer-portal-btn" to="/admin/analytics/campaigns">Analytics campañas</Link>
          </div>
        </>
      ) : null}
    </LaunchShell>
  );
}
